import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import bffApiCaller from '../../actions/bffApiCaller';

interface CaptchaGuardProps {
    children: React.ReactNode;
}

const CaptchaGuard: React.FC<CaptchaGuardProps> = ({ children }) => {
    const [isVerified, setIsVerified] = useState<boolean | null>(null);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const checkVerification = async () => {
            try {
                // Endpoint to check if user has the Clearance Cookie
                await bffApiCaller.get('/api/v1/captcha/check-verification');
                setIsVerified(true);
            } catch (err) {
                setIsVerified(false);
                history.replace('/verification', { from: location.pathname });
            }
        };

        checkVerification();
    }, [history, location]);


    if (isVerified === null) {
        return <div className="loading"><div className="loader"></div></div>;
    }

    return isVerified ? <>{children}</> : null;
};

export default CaptchaGuard;
